import { useMedia } from "react-use";
import { ChevronDownIcon, CrossIcon } from "@100mslive/react-icons";
import {
  config as cssConfig,
  Flex,
  IconButton,
} from "@100mslive/roomkit-react";

const EventReplayChatTop = props => {
  const { visibleChat, setVisibleChat } = props;
  const isMobile = useMedia(cssConfig.media.md);
  return isMobile ? (
    <Flex
      className="attendee-area-col-replay-layout-chat-header"
      onClick={() => {
        setVisibleChat(!visibleChat);
      }}
    >
      <div className="attendee-area-col-replay-layout-chat-header-heading">
        {visibleChat ? <> Event Replay Chat</> : <>Show chat</>}
      </div>

      <IconButton css={{ ml: "auto" }}>
        {visibleChat ? <CrossIcon /> : <ChevronDownIcon />}
      </IconButton>
    </Flex>
  ) : (
    <Flex className="attendee-area-col-replay-layout-chat-header">
      <div className="attendee-area-col-replay-layout-chat-header-heading">
        Event Replay Chat
      </div>
    </Flex>
  );
};

export default EventReplayChatTop;
